import Cursor from '@/components/common/cusor';
import Lines from '@/components/common/Lines';
import ProgressScroll from '@/components/common/ProgressScroll';
import Footer from '@/components/home-main/Footer';
import Navbar from '@/components/home-main/Navbar';
import { Helmet } from 'react-helmet';
import Story from './components/Story';

import Challenge from './components/Challenge';
import Header from '../project1/components/Header';

export default function Project2() {
  return (
    <>
      <Helmet>
        <title>Project2</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
 
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header title='Project 2' bgImg='https://images.unsplash.com/photo-1510906594845-bc082582c8cc?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDR8fHRlY2h8ZW58MHx8MHx8fDA%3D'/>
              <Challenge />
              <Story />
            </main>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
}
